import { jsx as r } from "react/jsx-runtime";
import { I as t } from "./vendor_rango__assets.57b7cd48.js";
import l from "react";
import h, { css as n } from "styled-components";
const g = h.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-hy3nys-0"
})(["color:var(--elements-icon-color);display:flex;box-sizing:content-box;", " svg{width:inherit;height:inherit;path{fill:currentColor;}}", " ", " ", ""], (o) => o.$inverse && n(["color:var(--inverse-icon-color);"]), (o) => o.size === e.SM && n(["width:var(--size-2x);height:var(--size-2x);"]), (o) => o.size === e.MD && n(["width:var(--size-2_5x);height:var(--size-2_5x);"]), (o) => o.size === e.LG && n(["width:var(--size-3x);height:var(--size-3x);"])), e = {
  SM: "SM",
  MD: "MD",
  LG: "LG"
};
Object.values(e);
const z = Object.keys(t), v = l.forwardRef(({
  size: o = e.MD,
  inverse: a = !1,
  icon: s,
  ...c
}, d) => {
  const i = t[s];
  return /* @__PURE__ */ r(g, { ...c, size: o, $inverse: a, ref: d, "data-testid": "rango-icon", "data-rango-component": "rango-icon", "data-is-rango": !0, children: (() => i ? /* @__PURE__ */ r(i, { "data-testid": "rango-icon-svg" }) : null)() });
});
v.displayName = "RangoIcon";
export {
  e as I,
  v as R,
  g as a,
  z as i
};
